<form [formGroup]="form" (ngSubmit)="submitted.next()" novalidate>
  <div class="gmb-8">
    <div class="w-100 gmb-16 gmb-sm-0 d-inline-flex">
      <ng-component
        *ngTemplateOutlet="
          inputField;
          context: {
            metric: configuration.measurementMetrics[0],
            controlName: 'weight',
            unitIndex: 0,
            focused: true
          }
        "
      ></ng-component>
    </div>
  </div>

  <div class="gmb-16 gmb-md-8">
    <ng-container *ngIf="isMetric; else imperialHeight">
      <ng-component
        *ngTemplateOutlet="
          inputField;
          context: {
            metric: configuration.measurementMetrics[1],
            controlName: 'heightCM',
            unitIndex: 0
          }
        "
      ></ng-component>
    </ng-container>
    <ng-template #imperialHeight>
      <div class="d-inline-flex w-50 gpr-12">
        <ng-component
          *ngTemplateOutlet="
            inputField;
            context: {
              metric: configuration.measurementMetrics[1],
              controlName: 'heightFT',
              unitIndex: 0
            }
          "
        ></ng-component>
      </div>
      <div class="d-inline-flex w-50 gpl-12">
        <ng-component
          *ngTemplateOutlet="
            inputField;
            context: {
              metric: configuration.measurementMetrics[1],
              controlName: 'heightIN',
              unitIndex: 1
            }
          "
        ></ng-component>
      </div>
    </ng-template>
  </div>

  <gpu-form-field [appearance]="formFieldAppearance">
    <gpu-label>
      {{ 'ANALYSES.ADD.DATE' | translate }}
    </gpu-label>
    <input
      id="value-date"
      name="date"
      type="text"
      gpuDatepicker
      ngbDatepicker
      #datepicker="ngbDatepicker"
      container="body"
      formControlName="date"
      [maxDate]="now"
      [minDate]="minDate"
      [datepicker]="datepicker"
      [placeholder]="'ANALYSES.ADD.DATE' | translate"
    />
    <i gpuSuffix class="gpicon-calendar"></i>
    <gpu-error *ngIf="form.controls.date?.errors?.required">
      {{ 'ANALYSES.ADD.REQUIRED' | translate }}
    </gpu-error>
  </gpu-form-field>

  <app-measurement-add-buttons
    [formValid]="form.valid"
    [editMode]="editMode"
    [isLoading]="false"
  ></app-measurement-add-buttons>

  <ng-template
    #inputField
    let-metric="metric"
    let-controlName="controlName"
    let-unitIndex="unitIndex"
    let-focused="focused"
  >
    <gpu-form-field
      class="gpu-wrapper-reserved"
      [appearance]="formFieldAppearance"
    >
      <gpu-label>
        {{ metric.name }} ({{ metric.units[unitIndex].name }})
      </gpu-label>
      <input
        type="text"
        gpuInput
        gpuLocalNumber
        [id]="controlName"
        [formControlName]="controlName"
        [name]="controlName"
        [placeholder]="'ANALYSES.SINGLE.VALUE' | translate"
        [focused]="focused"
        (blur)="trackInput($event, metric.id)"
      />
      <gpu-error *ngIf="form.get(controlName).errors?.required">
        {{ 'ANALYSES.VALUE_REQUIRED' | translate }}
      </gpu-error>
      <gpu-error *ngIf="form.get(controlName).errors?.pattern">
        {{ 'ANALYSES.VALUE_INVALID' | translate }}
      </gpu-error>
      <gpu-error *ngIf="form.get(controlName).errors?.min">
        {{ 'MIN_VALUE' | translate }}
      </gpu-error>
      <gpu-error *ngIf="form.get(controlName).errors?.max">
        {{ 'MAX_VALUE' | translate }}
      </gpu-error>
    </gpu-form-field>
  </ng-template>
</form>
